import React from "react";

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  makeStyles,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  autocompleteSkeleton: {
    marginTop: theme.spacing(3),
    maxWidth: "450px",
  },
}));

const TestCentresSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <Card>
      <CardHeader title={<Skeleton width={125} />} />
      <Divider />
      <CardContent>
        <Skeleton width={300} />
        <Skeleton className={classes.autocompleteSkeleton} height={75} />
      </CardContent>
    </Card>
  );
};

export default TestCentresSkeleton;
